(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-utils/use-media-query/assets/javascripts/values.js') >= 0) return;  svs.modules.push('/components/tb-utils/use-media-query/assets/javascripts/values.js');
"use strict";


const values = {
  BREAKPOINT_XS: 'xs',
  BREAKPOINT_SM: 'sm',
  BREAKPOINT_AM: 'am',
  BREAKPOINT_MD: 'md',
  BREAKPOINT_LG: 'lg',
  BREAKPOINT_XL: 'xl'
};

for (const key in values) {
  setGlobal("svs.components.tbUtils.useMediaQuery.".concat(key), values[key]);
}

 })(window);